import React from "react";
import styles from "./game-card.module.css";
import { formatDate } from "helpers/date";
import { useTranslation } from "react-i18next";

const FormattedDate = ({ date }) => {
  return <p className="subtitle-3 titlecase">{formatDate(date)}</p>;
};

const GameCard = ({ game, team_id }) => {
  const { t } = useTranslation();

  if (!game.game_id)
    return (
      <div className={styles["empty-game-card"]}>
        <p className="subtitle-2">
          {t("dashboard.previous-games.continue-your-streak")}
        </p>
      </div>
    );

  const currentTeam = game.team1.team_id === team_id ? game.team1 : game.team2;
  const opponentTeam = game.team1.team_id === team_id ? game.team2 : game.team1;

  return (
    <div className={styles["game-card"]}>
      <span className={`${styles["card-header"]} mb-12`}>
        <FormattedDate date={game.date} />
      </span>
      <div className={styles["card-content"]}>
        <div className={styles["game-data"]}>
          <div className={styles["data-container"]}>
            <div className={styles["data"]}>
              <img
                data-testid="current-team-logo"
                src={
                  currentTeam.logo
                    ? `logos/${currentTeam.logo}`
                    : `logos/first-team.png`
                }
                height="20"
                alt=""
              />
              <p className="title-4">{currentTeam.name}</p>
            </div>
          </div>
          <div className={styles.score}>
            <p
              className={`${styles["score-content"]} title-3`}
              data-testid="score"
            >
              {currentTeam.score ?? "-"}:{opponentTeam.score ?? "-"}
            </p>
          </div>
          <div className={styles["data-container"]}>
            <div className={styles["data"]}>
              <img
                data-testid="opponent-team-logo"
                src={
                  opponentTeam.logo
                    ? `logos/${opponentTeam.logo}`
                    : `logos/second-team.png`
                }
                height="20"
                alt=""
              />
              <p className="title-4">{opponentTeam.name}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameCard;
